import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-wrapper" }
const _hoisted_2 = { class: "main-container" }
const _hoisted_3 = { class: "left-menu" }
const _hoisted_4 = { class: "right-content" }
const _hoisted_5 = { class: "content-container" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "document-header" }
const _hoisted_8 = { class: "document-title" }
const _hoisted_9 = { class: "content-text" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["href"]

import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ArrowLeftBold } from '@element-plus/icons-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PdfViewer',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const pdfUrl = ref(route.query.url as string);
const pdfTitle = ref(route.query.title as string);
const activeMenu = computed(() => {
  return route.path;
});

onMounted(() => {
  if (route.query.url && route.query.title) {
    pdfUrl.value = decodeURIComponent(route.query.url as string);
    pdfTitle.value = decodeURIComponent(route.query.title as string);
  } else {
    // 如果没有参数，可以跳回或者显示错误
    router.push('/');
  }
});

const handleMenuSelect = (index: string) => {
  router.push(index);
};

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "menu-title" }, "政策规范", -1)),
        _createVNode(_component_el_menu, {
          "default-active": activeMenu.value,
          class: "el-menu-vertical",
          onSelect: handleMenuSelect
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "/policyAndfg" }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("span", null, "政策法规", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/learnRules" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("span", null, "学会规章制度", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/xiehuiRules" }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("span", null, "协会规章制度", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["default-active"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1))),
                class: "back-button",
                icon: _unref(ArrowLeftBold),
                text: "",
                bg: ""
              }, null, 8, ["icon"]),
              _createElementVNode("h1", _hoisted_8, _toDisplayString(pdfTitle.value), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("iframe", {
                src: pdfUrl.value,
                width: "100%",
                height: "600px",
                style: {"border":"1px solid #eee","border-radius":"4px"},
                frameborder: "0"
              }, [
                _cache[5] || (_cache[5] = _createTextVNode(" 您的浏览器不支持 PDF 预览，请 ")),
                _createElementVNode("a", {
                  href: pdfUrl.value,
                  target: "_blank"
                }, "点击下载", 8, _hoisted_11),
                _cache[6] || (_cache[6] = _createTextVNode("查看。 "))
              ], 8, _hoisted_10)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})